import React, { useEffect, useState } from 'react';
import { fetchDefaultAddresses } from '../services/api';
import { useNavigate } from 'react-router-dom';
import {useAppId} from "../AppIdContext";
import {useTranslation} from "react-i18next";

const CheckoutBlockService = ({ address, onAddressChange }) => {
    const navigate = useNavigate();
    const appId = useAppId();
    const {t} = useTranslation();

    if (!address) return null;

    return (
        <div className="checkout_block_service mode-checkout">
            <div className="checkout_block_service_title checkout_block_service_title_text bold">{t("checkout_block_service_delivery_text")}</div>


            <div className="checkout_block_service_details">
                {`${address.full_name}, ${address.flat} ${address.building}, ${address.street}, ${address.area}, ${address.city}, ${address.province}, ${address.postal_code}, ${address.country}`}
            </div>


            <div className="checkout_block_service_manage_addresses bold button" onClick={() => navigate('/address')}>{t("checkout_block_service_manage_addresses_text")}</div>
        </div>
    );
};

export default CheckoutBlockService;
